module.exports = __webpack_public_path__ + "static/media/linked_logo1 (1).4147c472.webp";